@if (stage() === 'prompt') {
  <div class="neat-deal-prompt">
    <span class="neat-deal-prompt__text">
      Your transcript is ready. Add optional deal context first?
    </span>
    <div class="neat-deal-prompt__actions">
      <button type="button" class="neat-deal-btn neat-deal-btn--primary"
        (click)="onYes()">Yes, add deal context</button>
      <button type="button" class="neat-deal-btn"
        (click)="onNo()">No, analyze now</button>
    </div>
  </div>
} @else {
  <div class="neat-deal-form">
    <div class="neat-deal-form__title">Deal context (optional)</div>
    <div class="neat-deal-form__grid">
      <label class="neat-deal-field">
        <span>Rep</span>
        <input type="text" [value]="rep()" (input)="onRep($event)" placeholder="e.g. Jordan Lee" />
      </label>
      <label class="neat-deal-field">
        <span>Account</span>
        <input type="text" [value]="account()" (input)="onAccount($event)" placeholder="e.g. Acme Corp" />
      </label>
      <label class="neat-deal-field">
        <span>Deal stage</span>
        <select [value]="dealStage()" (change)="onStage($event)">
          <option value="">—</option>
          @for (s of stages; track s) { <option [value]="s">{{ s }}</option> }
        </select>
      </label>
      <label class="neat-deal-field">
        <span>Opportunity type</span>
        <select [value]="opportunity()" (change)="onOpportunity($event)">
          <option value="">—</option>
          @for (o of opportunities; track o) { <option [value]="o">{{ o }}</option> }
        </select>
      </label>
    </div>
    <div class="neat-deal-form__footer">
      <button type="button" class="neat-deal-btn" (click)="onNo()">Skip</button>
      <button type="button" class="neat-deal-btn neat-deal-btn--primary"
        (click)="onContinue()">Continue with transcript</button>
    </div>
  </div>
}
